export default {
  title: {
    changePassword: '修改密码'
  },
  label: {
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码'
  },
  message: {
    passwordNotSame: '请确认密码相同',
    passwordSameAsPrevious: '新密码不能与旧密码相同',
    updateSuccess: '修改密码成功'
  }
}
